<footer class="footer">
  <ul>
    <li>© BENZ & CO. Festbetriebe GmbH {{ date }}</li>
    <li>
      <a href="https://www.beimbenz.de/impressum" target="_blank">Impressum</a>
    </li>
    <li>
      <a href="https://www.beimbenz.de/datenschutz" target="_blank"
        >Datenschutz</a
      >
    </li>
    <li><a href="https://www.beimbenz.de/agb" target="_blank">AGB</a></li>
  </ul>
</footer>
